import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import IndexMark from '@/components/index/IndexMark';

type ReviewerShellProps = {
  children: React.ReactNode;
  subtitle?: string;
};

export default function ReviewerShell({ children, subtitle }: ReviewerShellProps) {
  const navigate = useNavigate();
  const email = auth.currentUser?.email ?? '';

  return (
    <div className="min-h-screen flex flex-col bg-black ni-grid-bg text-white">
      <header className="sticky top-0 z-40 border-b border-[#2a2a2a] bg-black/95 backdrop-blur-sm">
        <div className="flex items-center justify-between gap-4 px-4 py-3">
          <div className="flex items-center gap-4 min-w-0">
            <Link to="/reviewer" className="shrink-0">
              <IndexMark compact />
            </Link>
            <div className="min-w-0">
              <p className="ni-id text-white/45 truncate">NUCLIUS://INDEX/REVIEWER</p>
              {subtitle && <p className="text-xs font-sans text-white/60 truncate">{subtitle}</p>}
            </div>
          </div>
          <nav className="flex items-center gap-4 shrink-0 text-xs font-mono uppercase tracking-wider">
            <Link to="/reviewer" className="text-white/55 hover:text-white">
              Panel
            </Link>
            <Link to="/reviewer/guide" className="text-white/55 hover:text-white">
              Guide
            </Link>
            <span className="hidden sm:inline text-white/40 normal-case tracking-normal font-sans">
              {email}
            </span>
            <button
              type="button"
              className="text-white/55 hover:text-white"
              onClick={() => {
                void signOut(auth).then(() => navigate('/login'));
              }}
            >
              Sign out
            </button>
          </nav>
        </div>
      </header>
      <main className="flex-1 overflow-auto ni-scroll px-4 py-6 md:px-6 md:py-8">{children}</main>
    </div>
  );
}
